<template>
	<modal
		:max-width="modalOptions.largura"
		:min-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="false"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		:acao-confirmar="confirmar"
		:is-confirmar-desabilitado="desabilitarBotaoConfirmar"
		is-confirmar-visivel
	>
		<template #body>
			<v-form v-model="isFormValid" ref="form" lazy-validation>
				<v-row class="mt-4">
					<v-col cols="12" sm="4">
						<label-personalizado
							nome-campo="Dias"
							:obrigatorio-por-padrao="prazoEntregaObrigatorio"
						></label-personalizado>
						<v-text-field
							v-model="dias"
							type="number"
							dense
							hide-spin-buttons
							placeholder="Informe"
							:rules="numeroDiasRules"
							@keydown="validarSeInputIsNumerico($event)"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="8">
						<label-personalizado
							nome-campo="Tipo de dias"
							:obrigatorio-por-padrao="prazoEntregaObrigatorio"
						></label-personalizado>
						<v-autocomplete
							v-model="tipoDias"
							:items="tipoDiasOptions"
							:rules="tipoDiasRules"
							placeholder="Selecione"
							item-value="value"
							item-text="text"
							dense
							clearable
						>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-form>
		</template>
	</modal>
</template>

<script>
import { tipoDias, actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'modal-prazo-entrega',
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		modalOptions: {
			type: Object,
			default: () => {
				return { largura: '500', altura: '400' }
			},
		},
		tituloModal: {
			type: String,
			default: () => 'Prazo de Entrega',
		},
	},
	data() {
		return {
			dias: null,
			tipoDias: null,
			isFormValid: false,
			MAXIMODIASPERMITIDO: 365,
			MINIMODIASPERMITIDO: 1,
		}
	},
	computed: {
		...mapState({
			itensAtaSelecionados: (state) => state.itemAta.itensAtaSelecionados,
			prazoEntregaObrigatorio: (state) => state.parametrosSistema.prazoEntregaObrigatorio,
		}),
		tipoDiasOptions() {
			return Object.values(tipoDias)
		},
		numeroDiasRules() {
			const rules = [(v) => this.validarMinMax(v) || 'Informe n° de 1 a 365']
			if (this.prazoEntregaObrigatorio) {
				rules.push((v) => this.regraObrigatoriedade(v, 'Dias é obrigatório.'))
			}
			return rules
		},
		tipoDiasRules() {
			const rules = []
			if (this.prazoEntregaObrigatorio) {
				rules.push((v) => this.regraObrigatoriedade(v, 'Tipo de dias é obrigatório.'))
			}
			return rules
		},
		desabilitarBotaoConfirmar() {
			return !this.isFormValid || (!this.prazoEntregaObrigatorio && !this.dias && !this.tipoDias)
		},
	},
	methods: {
		async confirmar() {
			if (!this.$refs.form.validate()) return

			await this.$store
				.dispatch(actionTypes.ITEM_ATA.SALVAR_INFORMACOES_PRAZO_ENTREGA, this.montarPayload())
				.then(() => {
					this.mostrarNotificacaoSucessoDefault()
					this.fecharModal(true)
				})
		},
		montarPayload() {
			const idsItens = this.itensAtaSelecionados.map((item) => item.id)
			return {
				idsItens: idsItens,
				dias: this.dias,
				tipoDias: this.tipoDias,
				isAlteracaoEmMassa: true,
			}
		},
		validarSeInputIsNumerico(evento) {
			const inputsInvalidos = ['e', '.', ',']
			const key = evento.key

			if (
				(!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key)) ||
				inputsInvalidos.some((keyInvalida) => evento.key === keyInvalida)
			) {
				evento.preventDefault()
			}
		},
		validarMinMax(valor) {
			return !valor || !(valor < this.MINIMODIASPERMITIDO || valor > this.MAXIMODIASPERMITIDO)
		},
		fecharModal(alterouPrazoEntrega = false) {
			this.$emit('fechar-modal', alterouPrazoEntrega)
		},
	},
}
</script>

<style lang="stylus" scoped></style>
